import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import './style.css';

export default class LoadingMaskView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: true
        };
    }

    static newInstance = function() {
        const div = document.createElement('div');
        document.body.appendChild(div);
        return ReactDOM.render(<LoadingMaskView />, div);
    };

    show = () => {
        this.setState({
            hidden: false
        });
    };

    hidden = () => {
        this.setState({
            hidden: true
        });
    };

    render() {
        const containerClassName = classnames({
            'rui-loadingMask': true,
            'rui-loadingMask-hidden': this.state.hidden
        });

        const dotClassName = classnames({
            'rui-loadingMask-dot': true,
            'rui-loadingMask-dot-spin': true
        });

        return (
            <div className={containerClassName}>
                <span className={dotClassName} onClick={this.hidden} title="点击隐藏">
                    <i />
                    <i />
                    <i />
                    <i />
                </span>
            </div>
        );
    }
}
